/*Bearer ${token}` 

=========================================================
* Vision UI  React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

/*Bearer ${token}`
 * The base colors for the Vision UI Dashboard  Material.
 * You can add new color using this file.
 * You can customized the colors for the entire Vision UI Dashboard  Material using thie file.
 */

export default {
  // Professional Accounting Light Theme Colors
  background: {
    default: "#f5f7fa",
  },

  sidenav: {
    button: "#1e3a5f",
  },

  text: {
    main: "#475569",
    focus: "#1e293b",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  brand: {
    main: "#1e3a5f",
    focus: "#2d4a73",
  },

  black: {
    light: "#141414",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#1e3a5f",
    focus: "#2d4a73",
  },

  secondary: {
    main: "#f1f5f9",
    focus: "#e2e8f0",
  },

  lightblue: {
    main: "#3b82f6",
    focus: "#60a5fa",
  },

  orange: {
    main: "#f59e0b",
    focus: "#fbbf24",
  },

  grey: {
    100: "#f8fafc",
    200: "#f1f5f9",
    300: "#e2e8f0",
    400: "#cbd5e1",
    500: "#94a3b8",
    600: "#64748b",
    700: "#475569",
    800: "#334155",
    900: "#1e293b",
  },

  borderCol: {
    main: "#e2e8f0",
    red: "#ef4444",
    navbar: "#e2e8f0",
  },

  // Functional colors
  info: {
    main: "#2563eb",
    focus: "#3b82f6",
    charts: {
      100: "#60a5fa",
      200: "#3b82f6",
      300: "#2563eb",
      400: "#1d4ed8",
      500: "#1e40af",
      600: "#1e3a8a",
    },
  },

  success: {
    main: "#059669",
    focus: "#10b981",
  },

  warning: {
    main: "#d97706",
    focus: "#f59e0b",
  },

  error: {
    main: "#dc2626",
    focus: "#ef4444",
  },

  light: {
    main: "#f1f5f9",
    focus: "#e2e8f0",
  },

  dark: {
    main: "#1e293b",
    focus: "#334155",
    body: "#0f172a",
  },

  gradients: {
    navbar: {
      deg: "180deg",
      main: "rgba(255, 255, 255, 0.95) 0%",
      state: "rgba(248, 250, 252, 0.95) 100%",
    },

    sidenav: {
      deg: "180",
      main: "rgba(255, 255, 255, 0.98) 0%",
      state: "rgba(241, 245, 249, 0.95) 100%",
    },

    borderLight: {
      angle: "94.43% 69.43% at 50% 50%",
      main: "#e2e8f0 0%",
      state: "rgba(226, 232, 240, 0) 100%",
    },

    borderDark: {
      angle: "69.43% 69.43% at 50% 50%",
      main: "#e2e8f0 0%",
      state: "rgba(226, 232, 240, 0) 100%",
    },

    cover: {
      deg: "159.02",
      main: "#1e3a5f 14.25%",
      state: "#162d4a 56.45%",
      stateSecondary: "#0f1f35 86.14%",
    },

    cardDark: {
      deg: "135",
      main: "rgba(255, 255, 255, 1) 0%",
      state: "rgba(248, 250, 252, 1) 100%",
    },

    cardLight: {
      deg: "135",
      main: "rgba(255, 255, 255, 1) 0%",
      state: "rgba(248, 250, 252, 1) 100%",
    },

    card: {
      deg: "135",
      main: "rgba(255, 255, 255, 1) 0%",
      state: "rgba(248, 250, 252, 1) 100%",
    },

    menu: {
      deg: "180",
      main: "#1e3a5f 0%",
      state: "#162d4a 100%",
    },

    cardContent: {
      deg: "135",
      main: "rgb(255, 255, 255) 0%",
      state: "rgb(248, 250, 252) 100%",
    },

    box: {
      deg: "135",
      main: "rgba(255, 255, 255, 1) 0%",
      state: "rgba(248, 250, 252, 1) 100%",
    },

    bill: {
      deg: "135",
      main: "rgba(255, 255, 255, 1) 0%",
      state: "rgba(241, 245, 249, 1) 100%",
    },

    primary: {
      deg: "135",
      main: "#1e3a5f",
      state: "#2d4a73",
    },

    secondary: {
      main: "#64748b",
      state: "#94a3b8",
    },

    logo: {
      deg: "97.89",
      main: "#ffffff 70.67%",
      state: "rgba(117, 122, 140, 0) 108.55%",
    },

    info: {
      main: "#2563eb",
      state: "#3b82f6",
    },

    success: {
      main: "#059669",
      state: "#10b981",
    },

    warning: {
      main: "#dc2626",
      state: "#f59e0b",
    },

    error: {
      main: "#dc2626",
      state: "#ef4444",
    },

    light: {
      main: "#e2e8f0",
      state: "#f1f5f9",
    },

    dark: {
      main: "#1e293b",
      state: "#334155",
    },
  },

  socialMediaColors: {
    facebook: { main: "#3b5998", dark: "#344e86" },
    twitter: { main: "#55acee", dark: "#3ea1ec" },
    instagram: { main: "#125688", dark: "#0e456d" },
    linkedin: { main: "#0077b5", dark: "#00669c" },
    pinterest: { main: "#cc2127", dark: "#b21d22" },
    youtube: { main: "#e52d27", dark: "#d41f1a" },
    vimeo: { main: "#1ab7ea", dark: "#13a3d2" },
    slack: { main: "#3aaf85", dark: "#329874" },
    dribbble: { main: "#ea4c89", dark: "#e73177" },
    github: { main: "#24292e", dark: "#171a1d" },
    reddit: { main: "#ff4500", dark: "#e03d00" },
    tumblr: { main: "#35465c", dark: "#2a3749" },
  },

  alertColors: {
    primary: { main: "#1e3a5f", state: "#2d4a73", border: "#bfdbfe" },
    secondary: { main: "#64748b", state: "#94a3b8", border: "#e2e8f0" },
    info: { main: "#2563eb", state: "#3b82f6", border: "#bfdbfe" },
    success: { main: "#059669", state: "#10b981", border: "#a7f3d0" },
    warning: { main: "#d97706", state: "#f59e0b", border: "#fde68a" },
    error: { main: "#dc2626", state: "#ef4444", border: "#fecaca" },
    light: { main: "#e2e8f0", state: "#f1f5f9", border: "#f8fafc" },
    dark: { main: "#1e293b", state: "#334155", border: "#cbd5e1" },
  },

  badgeColors: {
    primary: { basic: "#1e3a5f", background: "#dbeafe", text: "#1e3a5f" },
    secondary: { basic: "#64748b", background: "#f1f5f9", text: "#64748b" },
    info: { basic: "#2563eb", background: "#dbeafe", text: "#1d4ed8" },
    success: { basic: "#059669", background: "#d1fae5", text: "#059669" },
    warning: { basic: "#d97706", background: "#fef3c7", text: "#d97706" },
    error: { basic: "#dc2626", background: "#fee2e2", text: "#dc2626" },
    light: { basic: "#f8fafc", background: "#ffffff", text: "#94a3b8" },
    dark: { basic: "#1e293b", background: "#1e293b", text: "#fff" },
  },

  inputColors: {
    backgroundColor: "#ffffff",
    borderColor: { main: "#e2e8f0", focus: "#2563eb" },
    boxShadow: "#2563eb",
    error: "#dc2626",
    success: "#059669",
  },

  sliderColors: {
    thumb: { borderColor: "#cbd5e1" },
  },

  circleSliderColors: {
    background: "#e2e8f0",
  },

  tabs: {
    indicator: { boxShadow: "#e2e8f0" },
  },
};


